import { ProjectDetailPageState } from ".";

export const ProjectDetailPageInitialState: ProjectDetailPageState = {
  projectTickets: {
    interfaceDefinitions: [],
    componentProjects: [],
  },
  ifSpreadSheet: {
    tmplateRow: {
      tag: "",
      stgDplymntPlnDate: "",
      prdDplymntPlnDate: "",
      total: "0",
      stsDsgnDesigning: "0",
      stsDsgnReviewing: "0",
      stsStgDplymntPlanning: "0",
      stsStgDplymntPlanningBlocked: "0",
      stsStgDplymntAwaitingApproval: "0",
      stsStgDplymntPlanned: "0",
      stsPrdDplymntPlanning: "0",
      stsPrdDplymntPlanningBlocked: "0",
      stsPrdDplymntAwaitingApproval: "0",
      stsPrdDplymntPlanned: "0",
      stsCompleted: "0",
    },
  },
  cpntSpreadSheet: {
    tmplateRow: {
      pjtId: "",
      pjtName: "",
      stgSchedDplymntDate: "",
      prdSchedDplymntDate: "",
      dipByRgn: "",
      cpntId: "",
      cpntPjtTypeName: "",
      inOutTypeName: "",
      prtcolTypeName: "",
      reqTskSlctdFlg: "",
      stgIfdDplymntPsblFlg: "",
      prdIfdDplymntPsblFlg: "",
      completedFlg: "",
    },
  },
  projects: {
    projectInformation: {
      pjtName: "",
      pjtDesc: "",
      pjtStartPlnDate: "",
      pjtEndPlnDate: "",
      chnTypeGrpTypeCdList: [],
      chnTypeGrpTypeName: "",
      trnsMsnTypeCd: "",
      trnsMsnTypeName: "",
      reqEstmtAnsDueDate: "",
    },
    ifReqSTmpUpdLastDTime: "",
    ifReqSTmpUpdPath: "",
    tstUseTypeCd: "",
    tstUseTypeName: "",
    componentRequirementList: [],
    costEstimation: {
      pjtBdgtAcqstnReqTypeCd: "",
      pjtBdgtAcqstnReqTypeName: "",
      statsOfAgreementOnBudgetaryTypeCd: "",
      statsOfAgreementOnBudgetaryTypeName: "",
    },
    componentProjectList: [],
    stakeholderList: [],
    planStatus: {
      tcktId: "",
      stsId: "",
      availebleNxtStsIds: [],
      availableEvntGrps: [],
    },
    executionStatus: {
      tcktId: "",
      stsId: "",
      availebleNxtStsIds: [],
      availableEvntGrps: [],
    },
    invalidRoleList: [],
    pjtLnchTypeCd: "",
    pjtLnchTypeName: "",
    updateDateTime: "",
    mmTxt: "",
    mmTxtUpdateDateTime: "",
  },
};
